import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.054 5.313a.7.7 0 0 1 .99 0l4.695 4.696c.421.422.865.593 1.266.593.402 0 .846-.171 1.267-.593l4.683-4.686a.7.7 0 1 1 .99.99l-4.683 4.686c-.642.643-1.428 1.003-2.257 1.003-.827 0-1.614-.36-2.256-1.003L3.054 6.302a.7.7 0 0 1 0-.99Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.88 9.463a.7.7 0 0 1 .087.986l-4.035 4.82a.7.7 0 1 1-1.073-.899l4.034-4.82a.7.7 0 0 1 .986-.087Zm4.246 0a.7.7 0 0 1 .986.088l4.027 4.812a.7.7 0 0 1-1.074.898l-4.026-4.812a.7.7 0 0 1 .087-.986Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 5.898a1.7 1.7 0 0 1 1.7-1.7h12.6a1.7 1.7 0 0 1 1.7 1.7v8.204a1.7 1.7 0 0 1-1.7 1.7H3.7a1.7 1.7 0 0 1-1.7-1.7V5.898Zm1.7-.3a.3.3 0 0 0-.3.3v8.204a.3.3 0 0 0 .3.3h12.6a.3.3 0 0 0 .3-.3V5.898a.3.3 0 0 0-.3-.3H3.7Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=EmailIcon20.js.map